import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[dev-func-confirm-host]',
    standalone: false
})
export class DevFuncConfirmDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}